import React, { useEffect, useState } from "react";
import useSize from "../../../../Utils/useSize/useSize";
import Header from "./Header";
import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";

const fmt = require("indian-number-format");

export default function Profile() {
  const windowSize = useSize();
  const userType = Number(localStorage.getItem("user_type") || 7);

  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [backend, setBackend] = useState(null);

  // Initialize backend once
  useEffect(() => {
    (async () => {
      const b = await new Backend().init();
      setBackend(b);
    })();
  }, []);

  // Load profile data
  useEffect(() => {
    if (backend) loadProfile();
  }, [backend]);

  const loadProfile = async () => {
    setLoading(true);
    const data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
    };

    try {
      const response = await backend.profile(data);
      if (response.error === "False") {
        setProfile(response.profile);
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to load profile.");
    } finally {
      setLoading(false);
    }
  };

  const renderRow = (label, value, center = false) => (
    <div
      className={`paddingright paddingleft border-hover ${
        center ? "justify-center" : "justify-between"
      }`}
      style={{
        display: "flex",
        alignItems: "center",
        height: 40,
      }}
    >
      {!center && <div className="label bold">{label}</div>}
      <div className={`label bold ${center ? "large" : ""}`}>{value}</div>
    </div>
  );

  if (loading) {
    return (
      <div
        style={{
          width: windowSize[0],
          height: windowSize[1] - 100,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="label large">Loading profile...</div>
      </div>
    );
  }

  if (!profile) return null;

  return (
    <div
      style={{
        width: windowSize[0],
        height: windowSize[1] - 100,
        borderRadius: 10,
      }}
    >
      <Header profile={profile} />
      {renderRow("SERVER", profile.server)}
      {renderRow("USERNAME", profile.username)}
      {renderRow("NAME", profile.name)}
      {profile.type !== 4 ? renderRow("SHARING", profile.sharing) : null}
      {renderRow(
        "EXCHANGE",
        <>
          {profile.nse ? "NSE-FUTURE " : ""}
          {profile.mcx ? "MCX-FUTURE " : ""}
          {profile.mcx_options ? "MCX-OPTIONS " : ""}
          {profile.options ? "NSE-OPTIONS " : ""}
          {profile.nse_cash ? "NSE-EQUITY " : ""}
          {profile.comex ? "COMEX " : ""}
          {profile.crypto ? "CRYPTO " : ""}
          {profile.forex ? "FOREX " : ""}
          {profile.us_stock ? "US-STOCK " : ""}
          {profile.sgx ? "SGX " : ""}
          {profile.index ? "OTHERS " : ""}
          {profile.dgcx ? "DGCX " : ""}
          {profile.ncdex ? "NCDEX " : ""}
        </>
      )}
      {renderRow(
        "COMMISSION",
        <>
          {profile.nse ? `NSE (${profile.b_nse}) ` : ""}
          {profile.mcx
            ? `MCX (${profile.b_mcx_lot} L ${profile.b_mcx_volume} V ) `
            : ""}
          {profile.mcx_options ? `MCX-OPTIONS (${profile.b_mcx_options}) ` : ""}
          {profile.options ? `NSE-OPTIONS (${profile.b_options}) ` : ""}
          {profile.nse_cash ? `NSE-EQUITY (${profile.b_nse_cash}) ` : ""}
          {profile.comex ? `COMEX (${profile.b_comex}) $ ` : ""}
          {profile.crypto ? `CRYPTO (${profile.b_crypto}) $ ` : ""}
          {profile.forex ? `FOREX (${profile.b_forex}) $ ` : ""}
          {profile.us_stock ? `US-STOCK (${profile.b_us_stock}) $ ` : ""}
          {profile.sgx ? `SGX (${profile.b_sgx}) $ ` : ""}
          {profile.index ? `OTHERS (${profile.b_index}) $ ` : ""}
          {profile.dgcx ? `DGCX (${profile.b_dgcx}) $ ` : ""}
          {profile.ncdex ? `NCDEX (${profile.b_ncdex})` : ""}
        </>,
        true
      )}
      {renderRow(
        "MARGIN",
        <>
          {profile.nse ? `NSE (${profile.margin_nse}) ` : ""}
          {profile.mcx ? `MCX (${profile.margin_mcx}) ` : ""}
          {profile.mcx ? `MCX-OPTIONS (${profile.margin_mcx_options}) ` : ""}
          {profile.options ? `NSE-OPTIONS (${profile.margin_options}) ` : ""}
          {profile.nse_cash ? `NSE-EQUITY (${profile.margin_nse_cash}) ` : ""}
          {profile.comex ? `COMEX (${profile.margin_comex}) ` : ""}
          {profile.crypto ? `CRYPTO (${profile.margin_crypto}) ` : ""}
          {profile.forex ? `FOREX (${profile.margin_forex}) ` : ""}
          {profile.us_stock ? `US-STOCK (${profile.margin_us_stock}) ` : ""}
          {profile.sgx ? `SGX (${profile.margin_sgx}) ` : ""}
          {profile.index ? `INDEX (${profile.margin_index}) ` : ""}
          {profile.dgcx ? `DGCX (${profile.margin_dgcx}) ` : ""}
          {profile.ncdex ? `NCDEX (${profile.margin_ncdex}) ` : ""}
        </>,
        true
      )}
      {userType === 4 &&
        renderRow(
          "CREDIT",
          `${fmt.format(parseFloat(profile.deposit_total || 0).toFixed(2))} ${
            profile.rupee_dollar === 1 ? "$" : "₹"
          }`
        )}
      {userType === 4 &&
        renderRow(
          "BALANCE",
          `${fmt.format(parseFloat(profile.deposit_current || 0).toFixed(2))} ${
            profile.rupee_dollar === 1 ? "$" : "₹"
          }`
        )}
      {profile.nse_cash === 1 && userType === 4 && (
        <>
          {renderRow(
            "DEPOSIT",
            `${fmt.format(
              parseFloat(profile.deposit_interest || 0).toFixed(2)
            )} ${profile.rupee_dollar === 1 ? "$" : "₹"}`
          )}
          {renderRow(
            "DEPOSIT INTEREST",
            `${fmt.format(
              parseFloat(
                (profile.deposit_total || 0) - (profile.deposit_interest || 0)
              ).toFixed(2)
            )} ${profile.rupee_dollar === 1 ? "$" : "₹"}`
          )}
          {renderRow(
            "INTEREST RATE",
            `${fmt.format(
              parseFloat(profile.deposit_interest_rate || 0).toFixed(2)
            )} %`
          )}
        </>
      )}
    </div>
  );
}
